import { cx } from "class-variance-authority";
import { toWrappableString } from "./utils/wrappable-string";

export const lineClampValues = {
  none: "line-clamp-none",
  1: "line-clamp-1",
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  5: "line-clamp-5",
  6: "line-clamp-6",
} as const;

export type LineClampValues = keyof typeof lineClampValues;

export interface WrapClampSpanProps extends React.HTMLProps<HTMLSpanElement> {
  // Only 'string' allowed so that we can easily use toWrappableString() on the child text, while still allowing HTML-like usage
  children: string;
  // Currently only allowed values for Tailwind line-clamp class. Can add more in Tailwind config
  lineClamp?: LineClampValues;
  wrappingThreshold?: number;
}

const WrapClampSpan = ({
  children,
  lineClamp = "none",
  className,
  wrappingThreshold,
  ...props
}: WrapClampSpanProps) => {
  const clampValue = lineClampValues[lineClamp];
  const cn = cx(`${clampValue} hyphen-wrap`, className);
  return (
    // Span is used so that the text can be put in the appropriate block text element, e.g. <p>, <h1>, <h2>.
    <span {...props} className={cn}>
      {wrappingThreshold !== undefined
        ? toWrappableString(children, wrappingThreshold)
        : children}
    </span>
  );
};

export default WrapClampSpan;
